<template>
  <div class="invite-view">
    <h2>Welcome <strong>{{ inviteId }}</strong>, you can now exchange files end-to-end encrypted with any other user.</h2>
  </div>
</template>

<script>
export default {
  name: 'InviteView',
  computed: {
    isInviteEmail() {
      return this.$route.query.reason === 'invite-email';
    },
    inviteId() {
      return this.$route.params.id;
    }
  }
};
</script>

<style scoped>
.invite-view {
  max-width: 500px;
  margin: 2rem auto;
  padding: 2rem;
  background: #f9f9f9;
  border-radius: 8px;
  text-align: center;
}
</style> 